export enum DriverReactQuery {
  GetDriversWithCar = 'getDriversWithCar'
}
